import React, { useCallback } from 'react'
import { Box, Button, Typography } from '@mui/material'

import { rudderslabTrackOnClick } from '../utils/common'

import { useGlobalState } from './SiteSearch'
import { PortableText } from './PortableText'
import { GradientBorderButton } from './GradientBorderButton'

export type HeroBanner404Props = {
  herobannertitle: string
  herobannersmalltitle: string
  herobannercontent: object
  herobannerbutton: {
    _key: string
    btntext: string
    btnlink: string
    btnexternallink: boolean
    btnhiglight: boolean
  }[]
  location: { pathname: string }
}

export const HeroBanner404 = ({ location, ...props }: HeroBanner404Props) => {
  const [showModal, setShowModal] = useGlobalState('showModal') // eslint-disable-line @typescript-eslint/no-unused-vars
  const [initialSearch, setInitialSearch] = useGlobalState('initialSearch') // eslint-disable-line @typescript-eslint/no-unused-vars

  const search = location.pathname.slice(1)

  const onClickSearch = useCallback(() => {
    setInitialSearch(search)
    setShowModal(true)
  }, [search, setInitialSearch, setShowModal])

  return (
    <Box
      sx={{
        background: 'url(/images/banner-404.jpg)',
        backgroundPosition: '0 100%',
        backgroundRepeat: 'no-repeat',
        backgroundSize: '100%',
        pt: { xs: 8.5, laptop: 13 },
        textAlign: 'center'
      }}>
      <Typography
        sx={{
          color: 'primary.dark',
          fontSize: 28,
          fontWeight: 500,
          mt: { xs: 2, mobile: 12, laptop: 7 }
        }}>
        {props.herobannersmalltitle}
      </Typography>

      <Typography
        variant='h1'
        sx={{
          color: 'primary.dark',
          fontSize: { xs: 128, mobile: 350 },
          lineHeight: { xs: 1.4, mobile: 1 }
        }}>
        {props.herobannertitle}
      </Typography>

      <PortableText
        blocks={props.herobannercontent}
        trackSectionHeader={props.herobannertitle}
        sx={{ '.MuiTypography-body1': { color: 'text.secondary', mt: 3 } }}
      />

      <Box
        sx={{
          width: 'calc(100% - 48px)',
          alignItems: 'center',
          display: 'flex',
          flexDirection: { xs: 'column', mobile: 'row' },
          justifyContent: 'center',
          mt: 5,
          mx: 3,
          pb: { xs: 5, laptop: 40 }
        }}>
        {props.herobannerbutton.map(item => (
          <GradientBorderButton
            key={item._key}
            link={item.btnlink}
            linkText={item.btntext}
            externalLink={item.btnexternallink}
            disableGradient={item.btnhiglight}
            handleClick={e =>
              rudderslabTrackOnClick('button', props.herobannertitle, e)
            }
            sx={{ width: { xs: '100%', mobile: 'fit-content' } }}
            textSx={{ px: 8, zIndex: 0 }}
          />
        ))}

        <Button
          sx={{
            ml: { mobile: 2 },
            mt: { xs: 2, mobile: 0 },
            p: 2,
            borderRadius: 2,
            textTransform: 'none'
          }}
          onClick={onClickSearch}>
          {`Search for "${search}"`}
        </Button>
      </Box>
    </Box>
  )
}
